var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1875 13.8122H3.96667L11.8115 5.96745L11.0323 5.18828L3.1875 13.0331V13.8122ZM14.0604 5.20599L11.7937 2.93932L12.5375 2.19557C12.7382 1.99488 12.9861 1.89453 13.2813 1.89453C13.5764 1.89453 13.8243 1.99488 14.025 2.19557L14.8042 2.97474C15.0049 3.17543 15.1052 3.42335 15.1052 3.71849C15.1052 4.01363 15.0049 4.26155 14.8042 4.46224L14.0604 5.20599ZM13.3167 5.94974L4.39167 14.8747H2.125V12.6081L11.05 3.68307L13.3167 5.94974ZM11.4219 5.57786L11.0323 5.18828L11.8115 5.96745L11.4219 5.57786Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.e072f4546041071af4e3027d8615c33c.svg";
export { ForwardRef as ReactComponent };